import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "@/api";
import modalReducer from "./modal/ModalSlice";
import confirmReducer from "./confirm/ConfirmSlice"
import navigationReducer from "./NavigationSlice";
import loadingReducer from "./LoadingSlice";
import languageReducer from "./languageSlice";

/**
 * Redux Store 설정
 * - RTK Query baseApi reducer 등록
 * - 전역 상태 reducer 등록
 * - serializableCheck 비활성화
 * - RTK Query middleware 연결
 */
export const store = configureStore({
    reducer: {
        [baseApi.reducerPath]: baseApi.reducer,
        modal: modalReducer,
        confirm: confirmReducer,
        navigation: navigationReducer,
        loading: loadingReducer,
        language: languageReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(baseApi.middleware),
});